import React from 'react'
import { motion } from 'framer-motion'
import { Quote, ArrowRight, ArrowLeft } from 'lucide-react'

const HomeTestimonial = () => {
    return (
        <section className="bg-white py-24 relative overflow-hidden">
            <div className="container mx-auto px-6 relative z-10">
                <div className="flex flex-col lg:flex-row gap-16 items-center">
                    
                    {/* Left: Headers */}
                    <motion.div 
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        className="lg:w-1/3 space-y-6"
                    >
                        <p className="text-blue-600 font-bold tracking-[0.3em] text-[10px] uppercase">Testimonials</p>
                        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 syne leading-tight">
                            What Our Clients <br />
                            <span className="text-blue-600">Say About Us</span>
                        </h2>
                        <p className="text-slate-500 text-sm md:text-lg leading-relaxed mt-4 font-medium">
                            Read feedback from organization leaders, founders, and HR partners who have transformed their workforce operations and scaled their teams with Merida.
                        </p>
                        
                        <div className="flex items-center gap-4 pt-6">
                            <button className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all">
                                <ArrowLeft size={18} />
                            </button>
                            <button className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center text-white shadow-lg shadow-blue-600/20 hover:bg-blue-700 transition-all">
                                <ArrowRight size={18} />
                            </button>
                        </div>
                    </motion.div>

                    {/* Right: Review Card */}
                    <motion.div 
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        className="lg:w-2/3 w-full"
                    >
                        <div className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-xl shadow-blue-900/5 border border-slate-100 relative">
                            <Quote size={60} className="text-blue-50 absolute top-8 right-10 rotate-180" />
                            
                            <div className="flex items-center gap-4 mb-8 relative z-10">
                                <div className="flex text-yellow-400">
                                    {[1,2,3,4,5].map(star => (
                                        <svg key={star} className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                        </svg>
                                    ))}
                                </div>
                            </div>

                            <p className="text-lg md:text-lg text-slate-600 leading-relaxed font-medium mb-10 relative z-10">
                                "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet."
                            </p>

                            <div className="flex items-center gap-4 relative z-10">
                                <img 
                                    src={require('../../Assest/cards/testimonial.avif')} 
                                    alt="Testimonial Author"
                                    className="w-16 h-16 rounded-full object-cover border-2 border-slate-100 shadow-sm"
                                />
                                <div>
                                    <h4 className="font-bold text-slate-900 text-lg syne">Simon Árpád</h4>
                                    <p className="text-blue-600 text-sm font-medium">Global Accountability Officer</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    )
}

export default HomeTestimonial